<form role="form" [formGroup]="studentForm">
    <h1 mat-dialog-title>STUDENT</h1>
    <div mat-dialog-content>
      <p>{{data.title}}</p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstname" placeholder="Enter first name">
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastname" placeholder="Enter last name">
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Student Id</mat-label>
          <input matInput formControlName="studentid" placeholder="Enter ID">
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Phone Number</mat-label>
          <input matInput formControlName="phone" placeholder="Enter phone number">
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Email </mat-label>
          <input matInput formControlName="email" placeholder="Enter Email Address">
        </mat-form-field>
      </p>
 
        <!--<div formArrayName="studentClasses">
          <div *ngFor="let studentclass of studentClasses().controls; let i=index" [formGroupName]="i">     
                <mat-form-field>
                  <mat-label>Select Class</mat-label>
                  <mat-select formControlName="Class_SysRef">
                      <mat-option *ngFor="let class of (dataClassList$ | async)" [value]="class.sysRef">
                          {{class.className}}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
          </div>
      </div>-->
      
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Close</button>
      <button mat-button [mat-dialog-close]="data.email" cdkFocusInitial (click)="addStudent()">Save</button>
    </div>
    </form>
